/**
 * Montant en centimes → `12,50` : deux décimales, virgule française, sans séparateur de milliers
 * ni symbole (relisible tel quel par un champ de saisie, l'unité s'affiche à part).
 */
export const formatCentsAsDecimal = (cents: number): string =>
  (cents / 100).toFixed(2).replace('.', ',')

/** Montant en centimes → `12,50 €` (deux décimales, virgule française). */
export const formatCentsAsEuros = (cents: number): string => `${formatCentsAsDecimal(cents)} €`

/** Durée en secondes → `3 h 05`, ou `45 min` sous l'heure. */
export const formatSecondsAsHoursMinutes = (seconds: number): string => {
  // Arrondir le total d'abord : arrondir le reste après extraction des heures donnerait `1 h 60`.
  const totalMinutes = Math.round(seconds / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return hours > 0 ? `${hours} h ${String(minutes).padStart(2, '0')}` : `${minutes} min`
}

/**
 * Adresse sur une ligne, « 12 rue de la Benauge, 33100 Bordeaux » : libellé de la liste des hubs et
 * en-tête de la fiche hub (back-office), requête de géocodage des profils boutique et e-mail de création de boutique. Les parties vides
 * sont omises ; `null` si tout est vide. D'autres lignes d'adresse sont encore construites à la
 * main (panier, démographie) : les faire passer ici quand on y touche.
 */
export const formatAddressLine = (address: {
  address: string
  postalCode: string
  city: string
}): string | null => {
  const locality = [address.postalCode, address.city]
    .map((part) => part.trim())
    .filter((part) => part !== '')
    .join(' ')
  const parts = [address.address.trim(), locality].filter((part) => part !== '')
  return parts.length > 0 ? parts.join(', ') : null
}
